import { render, staticRenderFns } from "./glCard.vue?vue&type=template&id=42ad7e07&scoped=true"
import script from "./glCard.vue?vue&type=script&lang=js"
export * from "./glCard.vue?vue&type=script&lang=js"
import style0 from "./glCard.vue?vue&type=style&index=0&id=42ad7e07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad7e07",
  null
  
)

export default component.exports